import { 
    LOAD_LIST_DEPARTMENT, LOAD_A_DEPARTMENT, ADD_NEW_DEPARTMENT, UPDATE_A_DEPARTMENT, 
    DELETE_A_DEPARTMENT, CLEAR_A_DEPARTMENT_DETAIL, CLEAR_DEPARTMENT_ACTION_STATUS
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    departmentList: [],
    departmentDetail: null,
    loading: false,
    actionStatus: undefined,
    actionMsg: "",
    error: '',
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_DEPARTMENT: {
            return {
                ...state,
                departmentList: action.payload,
            }
        }

        case LOAD_A_DEPARTMENT: {
            return {
                ...state,
                departmentDetail: action.payload
            }
        }

        case ADD_NEW_DEPARTMENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                departmentList: [
                    action.payload.data,
                    ...state.departmentList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_DEPARTMENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                departmentList: state.departmentList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_DEPARTMENT: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                departmentList: state.departmentList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_DEPARTMENT_DETAIL: {
            return {
                ...state,
                departmentDetail: null,
            }
        }

        case CLEAR_DEPARTMENT_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}